import styled from 'styled-components'

import { tokens } from 'styling/tokens'

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 24rem;
  align-items: start;
  gap: 1rem;
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const SidePanel = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
`

export const KV = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: ${tokens.text.primary};
  b {
    font-weight: 600;
  }
`

export const Hint = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${tokens.text.secondary};
`

export const EventRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  font-size: 14px;
  color: ${tokens.text.primary};
  border-bottom: 1px solid ${tokens.border.hairline};
  &:last-child {
    border-bottom: none;
  }
`

export const TypeChip = styled.span<{ $closed?: boolean }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) =>
    props.$closed ? tokens.status.danger.fg + '26' : tokens.accent.base + '26'};
  color: ${(props) => (props.$closed ? tokens.status.danger.fg : tokens.accent.base)};
`

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 12px;
  color: ${tokens.text.secondary};
`

export const LegendDot = styled.span<{ $color: string }>`
  width: 0.75rem;
  height: 0.25rem;
  border-radius: 999px;
  background: ${(props) => props.$color};
`
